import { render, staticRenderFns } from "./stockItemsPage.vue?vue&type=template&id=a8b6cde6&"
import script from "./stockItemsPage.vue?vue&type=script&lang=ts&"
export * from "./stockItemsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports